import { useLocation } from "react-router";

export function useCurrentPath() {
  const { pathname } = useLocation();
  return pathname.split("/").pop() || "";
}
